import { $themeColors } from '@themeConfig'

// heat chart data generator
function generateDataHeatMap(count, yrange) {
  let i = 0
  const series = []
  while (i < count) {
    const x = `w${(i + 1).toString()}`
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min

    series.push({
      x,
      y,
    })
    // eslint-disable-next-line no-plusplus
    i++
  }
  return series
}

// colors
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}

export default {
  netStaking: {
    series: [
      {
        name: 'Delegations',
        data: [],
      },
      {
        name: 'Undelegations',
        data: [],
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          autoScaleYaxis: true
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [chartColors.area.series2],
        colors: [chartColors.area.series2],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      fill: {
        type: 'solid',
      },
      labels: [],
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        logarithmic: false,
      },
      colors: [$themeColors.success, $themeColors.danger],
    },
  },
  newWallets: {
    series: [
      {
        name: 'New Wallets',
        type: 'area',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
      {
        name: 'Cumulative',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [chartColors.area.series2],
        colors: [chartColors.area.series2],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: 'solid',
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: [
        {

        },
        {
          opposite: true,
        }
      ],
      colors: [chartColors.area.series3, 'orangered'],
    },
  },
  netGrowth: {
    series: [
      {
        name: "Users Joining",
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
      {
        name: "Users Leaving",
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
      {
        name: 'Net Growth',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [chartColors.area.series2],
        colors: [chartColors.area.series2],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: 'solid',
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: [
        {
          seriesName: "Users Joining",
        },
        {
          seriesName: "Users Joining",
          labels: {
            show: false
          },

        },
        {
          seriesName: "Users Joining",
          opposite: true,
        }
      ],
      colors: [$themeColors.success, $themeColors.danger, 'lightblue'],
    },
  },
  newTraffic: {
    series: [
      {
        name: 'Wallets Created <1y',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
      {
        name: 'Total Transactions',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [chartColors.area.series2],
        colors: [chartColors.area.series2],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: 'solid',
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        logarithmic: true,
      },
      colors: [chartColors.area.series3, 'orangered'],
    },
  },
  newNFT: {
    series: [
      {
        name: 'Wallets Created <1y',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
      {
        name: 'Total Transactions',
        type: 'line',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      }
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 2,
        strokeOpacity: 1,
        strokeColors: [chartColors.area.series2],
        colors: [chartColors.area.series2],
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: 'solid',
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        logarithmic: true,
      },
      colors: [chartColors.area.series3, 'orangered'],
    },
  },
  activeWallets: {
    series: [
      {
        name: 'Active Wallets',
        type: 'area',
        data: [
          {
            x: new Date(1538778600000),
            y: 150,
          }
        ],
      },
    ],
    chartOptions: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2.5,
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.8,
          opacityTo: 0.4,
          stops: [0, 80, 100],
        },
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: [
        {
          logarithmic: false,
        },
      ],
      colors: [chartColors.area.series3, chartColors.area.series2, chartColors.area.series1],
    },
  },
}
